export default "__VITE_ASSET__C15E2xpC__"